import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.mypage');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-mypage',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.mypage/view.scss */
:host {
  display: block;
}

.mypage-page {
  color: #111827;
}

.profile-card,
.profile-password {
  border-color: rgba(15, 23, 42, 0.08);
  background: #fff;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.98), 0 2px 8px rgba(15, 23, 42, 0.04), 0 18px 42px rgba(15, 23, 42, 0.055);
}

.profile-avatar {
  background: #f2c84b;
  color: #18181b;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.45), 0 5px 14px rgba(159, 112, 17, 0.14);
}

.profile-identity {
  border-color: #e7e7e4;
  background: #f7f7f5;
}

.profile-label {
  display: block;
  margin-bottom: 0.45rem;
  color: #68686d;
  font-size: 0.7rem;
  font-weight: 700;
}

.profile-input {
  display: block;
  width: 100%;
  border: 1px solid rgba(15, 23, 42, 0.12);
  border-radius: 0.75rem;
  padding: 0.75rem 0.875rem;
  background: #fff;
  color: #111827;
  font-size: 0.82rem;
  outline: none;
  transition: border-color 0.15s, box-shadow 0.15s;
  min-height: 2.875rem;
}

.profile-input:focus {
  border-color: #b58a22;
  box-shadow: 0 0 0 3px rgba(181, 138, 34, 0.12);
}

.profile-input:disabled {
  cursor: not-allowed;
}

.profile-save {
  background: #18181b;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.1), 0 5px 14px rgba(15, 23, 42, 0.14);
  transition: transform 0.16s ease, box-shadow 0.16s ease, background-color 0.16s ease;
}

.profile-save:hover:not(:disabled) {
  background: #27272a;
  box-shadow: 0 8px 20px rgba(15, 23, 42, 0.18);
  transform: translateY(-1px);
}

.profile-password[open] {
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.98), 0 3px 10px rgba(15, 23, 42, 0.05), 0 22px 48px rgba(15, 23, 42, 0.07);
}`],
})
export class PageMypageComponent implements OnInit {
    public loading: boolean = true;
    public saving: boolean = false;
    public changingPassword: boolean = false;
    public loadError: string = '';
    public user: any = {};
    public profileData: any = { name: '', mobile: '' };
    public passwordData: any = {
        current: '',
        password: '',
        passwordConfirm: ''
    };

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        const allowed = await this.service.auth.allow('/access');
        if (!allowed) return;
        await this.load();
    }

    public async load() {
        this.loading = true;
        this.loadError = '';
        await this.service.render();

        try {
            const { code, data } = await wiz.call('profile');
            if (code !== 200) {
                this.loadError = data.message || '회원 정보를 불러오지 못했습니다.';
                return;
            }
            this.user = data.user || {};
            this.profileData.name = this.user.name || '';
            this.profileData.mobile = this.user.mobile || '';
        } catch (error) {
            this.loadError = '연결을 확인한 뒤 다시 시도해주세요.';
        } finally {
            this.loading = false;
            await this.service.render();
        }
    }

    public async saveProfile() {
        if (this.saving) return;
        this.saving = true;
        await this.service.render();

        const { code, data } = await wiz.call('update_profile', this.profileData);
        this.saving = false;
        if (code === 200) {
            this.user = data.user;
            if (this.service.auth.session) {
                this.service.auth.session.name = this.user.name;
            }
            await this.notice(data.message, 'success');
            await this.service.render();
            return;
        }

        await this.notice(data.message || '저장하지 못했습니다.', 'error');
        await this.service.render();
    }

    public async changePassword() {
        if (this.changingPassword) return;
        if (!this.passwordData.current || !this.passwordData.password) {
            return await this.notice('비밀번호를 입력해주세요.', 'error');
        }
        if (this.passwordData.password !== this.passwordData.passwordConfirm) {
            return await this.notice('새 비밀번호가 일치하지 않습니다.', 'error');
        }

        this.changingPassword = true;
        await this.service.render();
        const { code, data } = await wiz.call('change_password', {
            current_password: this.passwordData.current,
            new_password: this.passwordData.password
        });
        this.changingPassword = false;

        if (code === 200) {
            this.passwordData = { current: '', password: '', passwordConfirm: '' };
            await this.notice(data.message, 'success');
            await this.service.render();
            return;
        }

        await this.notice(data.message || '비밀번호를 변경하지 못했습니다.', 'error');
        await this.service.render();
    }

    public async notice(message: string, status: string) {
        return await this.service.modal.show({
            title: '',
            message,
            cancel: false,
            action: '확인',
            actionBtn: status,
            status
        });
    }

    public roleName(role: string) {
        return role === 'admin' ? '관리자' : '사용자';
    }

    public shortDate(value: any) {
        return String(value || '').replace('T', ' ').slice(0, 16);
    }
}

export default PageMypageComponent;